/// <amd-module name="Build/Common/Commands/confirmpipelineaction/Command.types" />

import { IVssComponentProperties } from "VSS/Platform/Layout";

export interface IConfirmPipelineActionProps extends IVssComponentProperties {
    title: string,
    message: string,
    confirmLabel?: string,
    cancelLabel?: string,
    isDanger?: boolean,
    onClose: () => any;
    onConfirm: () => any;
}
